@if (products?.length) {
  <div class="products-slider__title">
    <h2 class="products-slider__title-text" translate>{{ title }}</h2>
    <div class="swiper-scrollbar"></div>
  </div>

  @if (isServer()) {
    <div class="swiper-container-placeholder">
      @for (prod of products | slice: 0 : 6; track prod) {
        <app-product-list-item [product]="prod" idPrefix="related">
        </app-product-list-item>
      }
    </div>
  } @else {
    <swiper-container
      appSwiper
      #swiperContainer
      init="false"
      [config]="sliderConfig"
      class="swiper-{{ className }}"
    >
      @for (prod of products; track prod) {
        <swiper-slide>
          <app-product-list-item [product]="prod" idPrefix="related">
          </app-product-list-item>
        </swiper-slide>
      }
    </swiper-container>

    <div class="swiper-{{ className }} swiper-button swiper-button-prev">
      <mat-icon class="swiper-button__icon">chevron_left</mat-icon>
    </div>
    <div class="swiper-{{ className }} swiper-button swiper-button-next">
      <mat-icon aria-hidden="" class="swiper-button__icon">chevron_right</mat-icon>
    </div>
  }
}
